import React from "react";

const QuotesRoutes = [
  {
    path: "/subscriptions",
    exact: true,
    component: React.lazy(() => import("./index")),
  },
  {
    path: "/subscription/add",
    component: React.lazy(() => import("./AddSubscriptionsPlan")),
  },
  {
    path: "/subscription/edit/:id",
    component: React.lazy(() => import("./AddSubscriptionsPlan")),
  },
];

export default QuotesRoutes;
